/**
 * 用户迁移, 第三步 二次授权
 * */
import React, { Fragment, PureComponent } from 'react';
import qs from 'qs';
import { message, Modal } from 'antd';
import {
  _check_login_token,
  _get_point,
  _h5_link_to,
  _link_kf,
} from '../../../store/Action';
import SecondaryAuthError from './SecondaryAuthError';
import OtherChangeBindPhone from '../../bindPhone/OtherChangeBindPhone';
import SecondaryAuthSuccess from './SecondaryAuthSuccess';
import IframeModal from '../../iframModal/IframModal';
import Util from '../../../script/util';

export default class SecondaryAuthorization extends PureComponent {
  state = {
    wx_visible: false, // 展示用户中心的微信二维码
    wx_url: null, // 用户中心的微信链接地址
    qq_visible: false,
    qq_url: null,
  };

  componentDidMount() {
    window.loginSuccessSecondary = (token, register) => {
      if (!token) {
        message.error('该账号注销中，无法登录。有问题请联系客服处理~');
        return;
      }
      if (typeof token === 'string') {
        register == 1 && this.hideWXModal();
        register == 2 && this.hideQQModal();
        _get_point(() => {
          _check_login_token(token, register || 1, null, 2);
        });
      }
    };
  }

  // QQ 二次授权
  QQSecondaryModal = () => {
    const { base } = this.props;
    const { rootConfig } = base;
    const search = {
      v: rootConfig.version,
      ty: 'second',
      origin: 2,
    };
    // 换绑定手机号，修改 ty
    const callbackURI = `${window.location.protocol}//${window.location.host}/loginCallback.html?${qs.stringify(search)}`;
    const param = {
      display: '',
      callbackURI,
      companyId: rootConfig.companyId,
      appKey: rootConfig.appKey,
      appSecret: '',
      appType: 1,
      appChannel: '',
      oauthType: 2,
    };
    const url =
      'https://reg-saas.whweidu.com/v2/thirdparty/qq/login.do?' +
      qs.stringify(param);
    const browser = Util.getBrowserInfo();
    if (browser.name == 'chrome' && parseInt(browser.version) >= 80) {
      this.setState({
        qq_visible: false,
        qq_url: null,
      });
      const l = (window.screen.availWidth - 780) / 2;
      const t = (window.screen.availHeight - 549) / 2;
      window.open(
        url,
        '第三方登录',
        'height=549,innerHeight=549,width=780,innerWidth=780,top=' +
          t +
          ',left=' +
          l +
          ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'
      );
    } else {
      this.setState({
        qq_visible: true,
        qq_url: url,
      });
    }
  };

  // 微信 二次授权
  WXSecondaryModal = () => {
    const { base } = this.props;
    const { rootConfig } = base;
    const search = {
      v: rootConfig.version,
      ty: 'second',
      origin: 1,
    };
    // 换绑定手机号，修改 ty
    const callbackURI = `${window.location.protocol}//${window.location.host}/loginCallback.html?${qs.stringify(search)}`;
    const param = {
      display: '',
      callbackURI,
      companyId: rootConfig.companyId,
      appKey: rootConfig.appKey,
      appSecret: '',
      appType: 1,
      appChannel: '',
    };
    const url =
      'https://reg-saas.whweidu.com/v2/thirdparty/wechat/bind/login.do?' +
      qs.stringify(param);

    this.setState({
      wx_visible: true,
      wx_url: url,
    });
  };

  // 关闭微信二次授权弹窗
  hideWXModal = () => {
    this.setState({
      wx_visible: false,
      wx_url: null,
    });
  };

  // 关闭QQ二次授权弹窗
  hideQQModal = (type = 'close') => {
    if (type === 'cancel') {
      // 操作取消的流程
    }
    this.setState({
      qq_visible: false,
      qq_url: null,
    });
  };
  // 打开 H5 页面
  openAppealH5Model = (url) => {
    _h5_link_to(url).then((res) => {
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
    });
    window.onAppealListener = (msg) => {
      if (typeof msg.data === 'string') {
        if (msg.data === 'openServicePage') {
          // 跳转原生登录页面
          _link_kf();
        }
      }
    };
    window.addEventListener('message', window.onAppealListener);
  };
  removeIframeListener = () => {
    window.removeEventListener('message', window.onAppealListener);
    window.onAppealListener = null;
  };

  render() {
    const { base } = this.props;
    const { syUserLoginInfo } = base;
    const { wx_visible, wx_url, qq_visible, qq_url } = this.state;
    return (
      <Fragment>
        <Modal
          open={wx_visible}
          title="身份验证"
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          closable={false}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="500px"
        >
          <div className="weixin-second-auth-plan">
            {/* 移除关闭按钮 */}
            {/*<span className="close" onClick={this.hideWXModal}>
                        <Icon type="close-circle"/>
                      </span>*/}
            {wx_visible && wx_url ? (
              <Fragment>
                <p className="tip-text">
                  请使用当前登录的昵称为“
                  <span className="user-nick">{syUserLoginInfo.nickName}</span>
                  ”的微信号授权验证身份
                </p>
                <div className="iframe-border">
                  <iframe
                    src={wx_url}
                    title="QQ登录"
                    scrolling="no"
                    width="300px"
                    height="300px"
                  />
                </div>
                <div className="desc-text">
                  <span className="icon-weixin" />
                  微信扫码授权验证身份
                </div>
              </Fragment>
            ) : null}
          </div>
        </Modal>

        {/* QQ 登录 */}
        <Modal
          open={qq_visible}
          wrapClassName="daidai-modal-style"
          centered={true}
          title="身份验证"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="700px"
          zIndex="1006"
          onCancel={this.hideQQModal}
        >
          <div className="qq-login-plan">
            {qq_visible ? (
              <iframe
                src={qq_url}
                title="QQ登录"
                scrolling="no"
                width="700px"
                height="400px"
              />
            ) : null}
          </div>
        </Modal>

        {/* 二次授权错误弹窗 */}
        <SecondaryAuthError
          base={this.props.base}
          showWeixinLogin={this.WXSecondaryModal}
          showQQLogin={this.QQSecondaryModal}
          otherChangeBindPhoneElement={this.otherChangeBindPhoneElement}
        />
        {/* 身份验证成功授权 */}
        <SecondaryAuthSuccess
          base={this.props.base}
          openAppealH5Model={this.openAppealH5Model}
        />

        {/* 自助解绑手机号 */}
        <OtherChangeBindPhone
          ref={(el) => (this.otherChangeBindPhoneElement = el)}
          base={this.props.base}
        />

        {/* 通用H5弹窗 */}
        <IframeModal
          wrappedComponentRef={(el) => (this.iframeElement = el)}
          destroy={this.removeIframeListener}
        />
      </Fragment>
    );
  }
}
